export const filterFields = ['transactionId', 'takeOffType', 'level', 'imageName'] as const;
